/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Llm_ProviderInputs */

const en_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM Provider`)
};

const fr_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseur de LLM`)
};

const de_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM-Anbieter`)
};

const it_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitore di LLM`)
};

const ru_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик программ магистратуры в области права`)
};

const es_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor de LLM`)
};

const zh_cn2_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法学硕士提供者`)
};

const ja_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM（法学修士）提供機関`)
};

const hi_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एलएलएम प्रदाता`)
};

const pt_pt2_llm_provider = /** @type {(inputs: Llm_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornecedor de LLM`)
};

/**
* | output |
* | --- |
* | "LLM Provider" |
*
* @param {Llm_ProviderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const llm_provider = /** @type {((inputs?: Llm_ProviderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Llm_ProviderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_llm_provider(inputs)
	if (locale === "de") return de_llm_provider(inputs)
	if (locale === "it") return it_llm_provider(inputs)
	if (locale === "ru") return ru_llm_provider(inputs)
	if (locale === "es") return es_llm_provider(inputs)
	if (locale === "zh-CN") return zh_cn2_llm_provider(inputs)
	if (locale === "ja") return ja_llm_provider(inputs)
	if (locale === "hi") return hi_llm_provider(inputs)
	if (locale === "pt-PT") return pt_pt2_llm_provider(inputs)
	return en_llm_provider(inputs)
});